type KeyMap = Record<string, string>;

const DEFAULT_KEY_MAP: KeyMap = {
    quantity: 'qty',
    flavors: 'selectedFlavors',
    subTotal: 'totalPrice',
};

const toNum = (v: any): number | null => {
    if (v === null || v === undefined || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
};

export interface NormalizeOptions {
    keyMap?: KeyMap;
    stripMenuItemId?: boolean;
}

export const normalizeOrderForCart = (items: any[], opts: NormalizeOptions = {}): any[] => {
    const keyMap: KeyMap = { ...DEFAULT_KEY_MAP, ...(opts.keyMap ?? {}) };
    const stripMenuItemId = !!opts.stripMenuItemId;

    const transform = (value: any): any => {
        if (Array.isArray(value)) {
            return value.map(transform);
        }
        if (value && typeof value === 'object') {
            const src = value as Record<string, any>;
            const out: Record<string, any> = {};

            const idFromMenu = toNum(src.menu_item_id);
            if (idFromMenu !== null) out.id = idFromMenu;

            for (const k of Object.keys(src)) {
                if (stripMenuItemId && k === 'menu_item_id') continue;

                const renamed = keyMap[k] ?? k;
                let val = transform(src[k]);

                if (renamed === 'dough' && val === null) {
                    val = {};
                }

                if (renamed === 'id' && out.id != null) {
                    continue;
                }

                out[renamed] = val;
            }

            return out;
        }
        return value;
    };

    return transform(items);
};
